import { FC, PropsWithChildren } from "react";
import Skeleton from "react-loading-skeleton";
import { LoadingGroup } from "../LoadingGroup";
import { BaseProps } from "../../BaseProps";

/**
 * The `LoadingSkeleton` component properties.
 */
export interface LoadingSkeletonProps extends BaseProps {
  /**
   * The number of lines of skeletons to render. If count is a decimal number like 3.5, three full skeletons and one half-width skeleton will be rendered. Defaults to 1.
   */
  readonly count?: number;

  /**
   * A custom wrapper component that goes around the individual skeleton elements.
   */
  readonly wrapper?: FC<PropsWithChildren<unknown>>;

  /**
   * A custom class name for the <span> that wraps the individual skeleton elements.
   */
  readonly containerClassName?: string;
}

/**
 * A component which renders the loading skeleton when a loading operation is taking place. If not loading, the children of the component is rendered.
 */
export const LoadingSkeleton: FC<PropsWithChildren<LoadingSkeletonProps>> = ({
  count,
  wrapper,
  className,
  containerClassName,
  testId,
  style,
  children,
}: PropsWithChildren<LoadingSkeletonProps>): JSX.Element => {
  return (
    <LoadingGroup.Placeholder
      fallback={
        <Skeleton
          count={count}
          containerTestId={testId}
          wrapper={wrapper}
          className={className as string}
          containerClassName={containerClassName}
          style={style}
        />
      }
    >
      {children}
    </LoadingGroup.Placeholder>
  );
};
